var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bg_gray" }),
    _c(
      "div",
      { staticClass: "banklist" },
      [
        _c("headbox", {
          attrs: { title: "银行卡管理", bgColor: "#fff", isborder: "true" }
        }),
        _vm._l(_vm.banklist, function(items) {
          return _c("div", { key: items.id, staticClass: "bankbox" }, [
            _c("p", { staticClass: "titlebank" }, [_vm._v(_vm._s(items.bank))]),
            _c("p", { staticClass: "bankmunber" }, [
              _vm._v(_vm._s(_vm._f("BankOnlyFour")(items.num)))
            ])
          ])
        })
      ],
      2
    ),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "martop" }, [
      _vm._v(" 如需修改银行卡账号,请拨打客服电话"),
      _c("b", [_vm._v("4001 - 886 - 722")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }